import clsx from "clsx";
import React, { FC, useState } from "react";

import { AccordionItem } from "./accordion-item";

export interface AccordionProps {
  items: Queries.AccordionItemDataFragment[];
}

export const Accordion: FC<AccordionProps> = ({ items }) => {
  const [currentItemIndex, setCurrentItemIndex] = useState(0);

  return (
    <div className="flex flex-col">
      {items.map((item, i) => (
        <div
          className={clsx(
            "border border-x-0 border-b-gray-300 border-b-1",
            i === 0 ? "border-t-1 border-t-gray-300" : "border-t-0"
          )}
          key={i}
        >
          <AccordionItem
            {...item}
            isOpen={i === currentItemIndex}
            onOpen={() => setCurrentItemIndex(i)}
          />
        </div>
      ))}
    </div>
  );
};
